// Strip trailing slashes so a base can be concatenated with an absolute
// path without producing a double slash.
//
// Collapses a run of them, not just one: `app.baseURL` and the API base
// URLs come from config/env, where '/destek//' is a typo away, and the
// three call sites (the chat store's proxy path, useArticleHtml's link
// rewriting, and the attachment download route's upstream base) must agree
// on the result.
export function trimTrailingSlash(value: string | undefined | null): string {
  return String(value ?? '').replace(/\/+$/, '')
}
